import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

const ThemeContext = createContext(null);
const KEY = "theme";

const applyTheme = (t) => {
  const root = document.documentElement;
  root.classList.remove("light", "dark");
  root.classList.add(t);
  root.style.colorScheme = t;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", t === "light" ? "#F6F7FB" : "#07090E");
};

const initial = () => {
  const saved = localStorage.getItem(KEY);
  return saved === "light" || saved === "dark" ? saved : "dark";
};

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [theme, setThemeState] = useState(initial);

  useEffect(() => { applyTheme(theme); }, [theme]);

  useEffect(() => {
    if (user?.theme && user.theme !== theme && !localStorage.getItem(KEY)) setThemeState(user.theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user_id]);

  const setTheme = useCallback((t) => {
    setThemeState(t);
    localStorage.setItem(KEY, t);
    if (user) api.patch("/auth/me/preferences", { theme: t }).catch(() => {});
  }, [user]);

  const toggle = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [theme, setTheme]);

  return <ThemeContext.Provider value={{ theme, setTheme, toggle, isLight: theme === "light" }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
